<template>
  <div class="inner_wrap">
    <section class="content1">
      <div class="con1_txt">
        <img
          src="@/assets/images/event/2025-1-competition-announcement/content1_1.png"
          alt="대학교 대항전"
        />
      </div>
    </section>
    <section ref="counterContainer" class="content2">
      <div class="lapping">
        <img
          src="@/assets/images/event/2025-1-competition-announcement/content2.png"
          alt=""
        />
        <div class="count_user_box">
          <ul class="couter_wrap">
            <li>
              <i>1위</i>
              <img
                src="@/assets/images/event/2025-1-competition-announcement/first.png"
                alt="건양대학교"
              />
              <span class="collage">건양대학교</span>
              <span class="score counter">5,665</span> 점
            </li>
            <li>
              <i>1위</i>
              <img
                src="@/assets/images/event/2025-1-competition-announcement/second.png"
                alt="상명대학교"
              />
              <span class="collage">상명대학교</span>
              <span class="score counter">3,949</span> 점
            </li>
            <li>
              <i>1위</i>
              <img
                src="@/assets/images/event/2025-1-competition-announcement/third.png"
                alt="충북대학교"
              />
              <span class="collage">충북대학교</span>
              <span class="score counter">2,854</span> 점
            </li>
            <li>
              <i>4위</i>
              <img
                src="@/assets/images/event/2025-1-competition-announcement/fourth.png"
                alt="대구대학교"
              />
              <span class="collage">대구대학교</span>
              <span class="score counter">2,734</span> 점
            </li>
            <li>
              <i>5위</i>
              <img
                src="@/assets/images/event/2025-1-competition-announcement/fifth.png"
                alt="부산대학교"
              />
              <span class="collage">부산대학교</span>
              <span class="score counter">2,642</span> 점
            </li>
          </ul>
          <p class="info">
            ※1등-5등 순위 발표 후 개별추첨 기프티콘(MMS) 순차적 발송예정
          </p>
          <div class="ribon">
            <img
              src="@/assets/images/event/2025-1-competition-announcement/ribon.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
    <section class="content4">
      <div class="inner">
        <ul class="benefit_list">
          <li class="first_wrap">
            <div class="first">
              <img
                src="@/assets/images/event/2025-1-competition-announcement/competition_benefit1.png"
                alt=""
              />
            </div>
            <span class="apply_txt"
              >1등 대학교 이벤트 응모 학생 전원 아메리카노 증정!</span
            >
            <div class="gradi_box">
              <ul class="">
                <li>
                  <div class="topic_wrap naver">
                    <span>네이버 페이 포인트 쿠폰 5만원권</span>
                    <span>10명</span>
                  </div>
                  <div class="name_list">
                    배*연(9841), 현*은(3034), 이*연(3452), 박*수(0367),
                    이*택(4993), 정*린(6168), 이*운(7754), 안*형(6730),
                    장*슬(8112), 김*범(0863)
                  </div>
                </li>
                <li>
                  <div class="topic_wrap bhc">
                    <span>BHC 후라이드콤보 + 콜라 1.25L</span>
                    <span>10명</span>
                  </div>
                  <div class="name_list">
                    김*원(8426), 김*진(3296), 양*리(6738), 원*우(0537),
                    최*영(3410), 정*혜(0315), 박*수(3501), 배*경(7315),
                    김*현(6801), 김*광(9556)
                  </div>
                </li>
              </ul>
            </div>
          </li>
          <li class="second_wrap">
            <div class="second">
              <img
                src="@/assets/images/event/2025-1-competition-announcement/competition_benefit2.png"
                alt=""
              />
            </div>
            <div class="gradi_box">
              <ul class="">
                <li>
                  <div class="topic_wrap naver">
                    <span>네이버 페이 포인트 쿠폰 2만원권</span>
                    <span>5명</span>
                  </div>
                  <div class="name_list">
                    이*영(3820), 김*은(5103), 이*준(7320), 김*훈(7815),
                    이*주(5764)
                  </div>
                </li>
                <li>
                  <div class="topic_wrap bhc">
                    <span>BHC 후라이드콤보 + 콜라 1.25L</span>
                    <span>5명</span>
                  </div>
                  <div class="name_list">
                    유*우(7929), 김*현(2324), 김*연(3774), 염*연(8559),
                    박*승(7927)
                  </div>
                </li>
                <li>
                  <div class="topic_wrap mega">
                    <span>메가MGC커피 아메리카노</span>
                    <span>50명</span>
                  </div>
                  <div class="name_list mega" @click="toggleCaution(1)">
                    <span class="txt" :class="{ 'active': cautionStates[1] }">
                      당첨자 보기
                    </span>
                    <div v-show="cautionStates[1]">
                      최*빈(1585), 이*정(6832), 김*진(9131), 염*연(8559),
                      방*윤(2006), 김*영(0506), 박*영(9323), 이*정(2835),
                      임*아(4686), 박*빈(8296), 김*휘(5494), 이*민(6141),
                      박*영(5918), 양*원(7631), 김*진(2032), 정*안(7330),
                      정*윤(6344), 지*아(2952), 김*준(3193), 정*결(0791),
                      조*주(2120), 이*겸(5424), 홍*서(3751), 김*지(6010),
                      홍*진(5080), 양*은(2723), 남*우(4514), 강*은(9921),
                      박*민(9821), 이*민(6912), 이*유(6387), 이*휘(7987),
                      배*진(9263), 정*리(0418), 윤*진(1704), 이*연(1338),
                      서*민(2749), 홍*서(3944), 박*영(5071), 백*현(9165),
                      김*환(5125), 김*화(7969), 김*정(0919), 홍*린(5410),
                      김*진(1236), 강*이(9724), 오*정(9250), 이*윤(3469),
                      최*범(7449), 소*진(5192)
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </li>
          <li class="third_wrap">
            <div class="third">
              <img
                src="@/assets/images/event/2025-1-competition-announcement/competition_benefit3.png"
                alt=""
              />
            </div>
            <div class="gradi_box">
              <ul class="">
                <li>
                  <div class="topic_wrap naver">
                    <span>네이버 페이 포인트 쿠폰 2만원권</span>
                    <span>3명</span>
                  </div>
                  <div class="name_list">
                    송*윤(3167), 성*우(5594), 박*은(1711)
                  </div>
                </li>
                <li>
                  <div class="topic_wrap bhc">
                    <span>BHC 후라이드콤보 + 콜라 1.25L</span>
                    <span>3명</span>
                  </div>
                  <div class="name_list">
                    최*서(7456), 제*규(3163), 박*원(7877)
                  </div>
                </li>
                <li>
                  <div class="topic_wrap mega">
                    <span>메가MGC커피 아메리카노</span>
                    <span>30명</span>
                  </div>
                  <div class="name_list mega" @click="toggleCaution(2)">
                    <span class="txt" :class="{ 'active': cautionStates[2] }">
                      당첨자 보기
                    </span>
                    <div v-show="cautionStates[2]">
                      최*실(7456), 김*민(8459), 김*기(3011), 이*린(5087),
                      김*연(9423), 문*신(1362), 이*표(2910), 권*무(9147),
                      문*현(4243), 이*(2265), 김*하(0338), 이*원(0390),
                      정*연(1164), 도*중(3393), 이*솔(1410), 조*우(8682),
                      송*연(0738), 김*리(7108), 김*현(0326), 신*진(8901),
                      박*원(8901), 김*진(9326), 이*민(4334), 이*현(6860),
                      유*탁(3018), 김*영(1735), 민*희(6739), 이*을(0067),
                      유*호(5299), 조*숙(7538)
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </li>
          <li class="fourth_wrap">
            <div class="fourth">
              <img
                src="@/assets/images/event/2025-1-competition-announcement/competition_benefit4.png"
                alt=""
              />
            </div>
            <div class="gradi_box">
              <ul class="">
                <li>
                  <div class="topic_wrap mega">
                    <span>메가MGC커피 아메리카노</span>
                    <span>30명</span>
                  </div>
                  <div class="name_list mega" @click="toggleCaution(3)">
                    <span class="txt" :class="{ 'active': cautionStates[3] }">
                      당첨자 보기
                    </span>
                    <div v-show="cautionStates[3]">
                      조*은(2049), 반*민(5832), 김*주(2370), 조*(1758),
                      박*인(3677), 최*연(7262), 홍*진(8533), 정*진(6616),
                      박*현(5966), 손*민(7524), 김*진(0765), 김*현(7676),
                      이*진(2823), 서*지(1305), 민*현(1930), 김*미(9150),
                      김*선(4149), 김*민(9716), 윤*빈(8449), LI *N(6966),
                      김*희(3673), 윤*화(7110), 최*숙(8773), 김*영(3431),
                      서*민(7511), 김*주(1610), 서*수(6930), 박*빈(9925),
                      정*은(6307), LENG *ZE(0515)
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </li>
          <li class="fifth_wrap">
            <div class="fifth">
              <img
                src="@/assets/images/event/2025-1-competition-announcement/competition_benefit5.png"
                alt=""
              />
            </div>
            <div class="gradi_box">
              <ul class="">
                <li>
                  <div class="topic_wrap mega">
                    <span>메가MGC커피 아메리카노</span>
                    <span>30명</span>
                  </div>
                  <div class="name_list mega" @click="toggleCaution(4)">
                    <span class="txt" :class="{ 'active': cautionStates[4] }">
                      당첨자 보기
                    </span>
                    <div v-show="cautionStates[4]">
                      박*주(8972), 이*영(6362), 김*란(9573), 서*진(3117),
                      김*정(4531), 안*호(3743), 신*진(2645), 윤*연(6869),
                      송*영(6108), 김*욱(6092), SHI*U(6555), 장*영(4191),
                      현*훈(5535), 박*경(9928), 이*현(0475), 김현송(5082),
                      조*주(0639), 백*이(9104), 조*진(8267), 최*은(1433),
                      안*혁(9605), 김*은(0680), 우*진(9505), 정*주(5948),
                      김*진(1687), 김*니(6089), 배*인(0026), 신*정(1104),
                      이*한(4162), 전*현(0742)
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <div class="caution_wrap" @click="toggleCaution(0)">
      <span class="txt" :class="{ 'active': cautionStates[0] }">
        대학교 대항전 이벤트 유의사항
      </span>
      <transition @before-enter="beforeEnter" @enter="enter" @leave="leave">
        <div v-show="cautionStates[0]" class="slide_list">
          <div class="point_save">[포인트 적립 방법]</div>
          <div class="cau_wrap1">
            <ul>
              <li>
                · 학교 대항전의 포인트 제도는, 위 이벤트 에서만 사용 되며,
                이벤트 종료 즉시 소멸될 예정 입니다.
              </li>
              <li>
                · 포인트를 쌓는 방법에는 총 3가지가 있으며, 이는 아래와
                같습니다.
              </li>
            </ul>

            <dl>
              <dt>a. 2025.02.24 이전 회원가입</dt>
              <dd class="depth1">
                I. 2025.02.23 23시59분 기준 회원 정보 상 등록 되어있는 학교로
                포인트가 적립 됩니다.
              </dd>
              <dd class="depth1">
                II. 이벤트 시작 이후 등록 학교를 변경 하더라도 추가 포인트는
                적립되지 않습니다.
              </dd>
              <dt>
                b. 2025.02.24 이후 신규 회원가입 및 회원가입 시 학교 정보 입력
              </dt>
              <dd class="depth1">
                I. 2025.02.24 00시 00분 이후 신규 회원가입 및 회원가입 시 학교
                정보를 입력한 회원에 한해, 등록한 학교로 포인트가 적립 됩니다.
              </dd>
              <dt>c. 학교 정보 등록 후 도서 구매</dt>
              <dd class="depth1">
                I. 도서를 구매한 시점에, 회원정보에 등록되어있는 학교로 포인트가
                적립됩니다. 1. 2025.02.27일 등록된 학교 고연대 -> 연고대로 변경.
                2025.02.28 “심리학개론” 도서 구매 -> 연고대학교로 도서 구매
                포인트 적립,
              </dd>
              <dd class="depth1">
                II. 도서 가격에 따라 적립되는 포인트가 상이할 수 있습니다.
              </dd>
              <dd class="depth1">
                III. 도서 구매 후 환불 시, 적립되었던 포인트가 차감됩니다.
              </dd>
            </dl>
            <p>*등록한 학교 정보는 입력 시 부터 1달간 변경이 불가능 합니다.</p>

            <h2>경품 유의사항</h2>
            <dl>
              <dt>[네이버페이 포인트 쿠폰]</dt>
              <dd>
                · 본 경품은 전환 쿠폰으로 지급 예정이며 해당 쿠폰의 유효기간 내
                미 사용 시 자동 만료 처리됩니다. <br />
                (기간 내 미 사용으로 인한 불이익은 당사가 책임지지 않습니다.)
              </dd>
              <dd>
                · 본 쿠폰은 당첨자의 회원정보에 등록되어있는 휴대폰 번호로 자동
                발송 예정입니다.
              </dd>
              <dt>
                · 네이버페이 포인트의 유효기간은 적립 일로부터 10년이며 쿠폰
                등록 방법은 아래와 같습니다.
              </dt>
              <dd>- 네이버페이 홈 (pay.naver.com) 접속</dd>
              <dd>
                - 네이버 ID와 패스워드로 로그인(네이버페이 이용약관 동의 필수)
              </dd>
              <dd>
                - PC : 네이버페이 홈 > 혜택·쿠폰 > 쿠폰 > 쿠폰 등록 > 쿠폰번호
                입력
              </dd>
              <dd>
                - MO : 네이버페이 홈 > 페이 서비스(우측 상단 삼선 버튼) > 쿠폰 >
                쿠폰 등록 > 쿠폰번호 입력
              </dd>
              <dd>
                · 네이버페이 포인트는 1인 당 최대 200만원까지 보유하실 수
                있습니다.
              </dd>
              <dd>
                · 네이버페이 포인트 쿠폰이 정상적으로 등록된 경우 네이버페이 >
                포인트 메뉴에서 내역을 확인하실 수 있습니다. (반영에 최대 1분이
                소요됩니다.)
              </dd>
              <dd>
                · 네이버페이 포인트 쿠폰으로 등록된 금액은 적립 포인트로
                지급되며 취소 및 현금 인출이 불가합니다.
              </dd>
              <dd>
                · 네이버페이 포인트는 네이버 쇼핑/네이버 웹툰/네이버 예약을
                비롯한 45만개 이상 가맹점에서 현금처럼 이용하실 수 있습니다.
              </dd>
              <dd>
                · 일부 페이 가맹점에서는 포인트 사용이 제한될 수 있습니다.
              </dd>
              <dd>· 쿠폰 등록 오류 문의 : 네이버페이 고객센터 1588-3819</dd>

              <dt class="space">
                [메가MGC커피 (HOT) 아메리카노 모바일 교환권]
              </dt>
              <dd>
                · 본 교환권의 유효기간은 지급일로부터 30일까지로 기간 내 미사용
                시 자동 만료 처리됩니다. <br />(기간 내 미사용으로 인한 불이익은
                당사가 책임지지 않습니다.)
              </dd>
              <dd>
                · 전국 메가MGC커피 매장에서 사용 가능합니다. (일부매장 제외)
              </dd>
              <dd>
                · 본 상품 교환시 메가커피 스탬프 및 포인트 적립은 브랜드사
                정책에 따릅니다.
              </dd>
              <dd>
                · 브랜드사 정책은 메가커피앱 - 스탬프 - 스탬프 카드 적립
                유의사항 안내에서 확인 가능합니다.
              </dd>
              <dd>
                · 본 상품은 매장 내 재고가 없을 경우 동일 가격 이상의 다른
                상품으로 교환이 가능하며 차액은 추가 지불하여야 합니다.
              </dd>
              <dd>
                · 사용 불가 매장 : 건대 학생회관점, 동소문점, 강남역점,
                여의도파크원점, 홈플러스 안산선부점, 안양1번가점,
                의정부망월사점, 용인성복역점, 천안터미널점, 홈플러스 울산점,
                김해롯데워터파크점
              </dd>
              <dd>· 경품 관련 문의 : 기프티쇼(1588-6474)</dd>

              <dt class="space">[BHC 후라이드 + 콜라 1.25L]</dt>
              <dd>
                · 본 교환권의 유효기간은 지급일로부터 30일까지로 기간 내 미사용
                시 자동 만료 처리됩니다.(기간 내 미사용으로 인한 불이익은 당사가
                책임지지 않습니다.)
              </dd>
              <dd>
                · BHC 앱 [E교환권주문]&BHC홈페이지[온라인주문]을 통해 사용
                가능합니다. (일부매장 제외)
              </dd>
              <dd>
                · 매장(홀)취식 사용 시 일부 및 특수매장은 매장 판매가 기준으로
                제공되며 추가금이 발생할 수 있습니다.
              </dd>
              <dd>
                · 본 상품은 매장 상황 및 거리에 따라 배달 불가 및 배달료가
                발생할 수 있으며 지역에 따라 배달료가 상이할 수 있습니다.
              </dd>
              <dd>
                · 쿠폰에 명시되어있는 상품으로만 교환 가능합니다(타제품
                교환불가)
              </dd>
              <dd>· 경품 관련 문의 : 기프티쇼(1588-6474)</dd>
            </dl>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Competition2025-1-Announcement',
  data() {
    return {
      cautionStates: [false, false, false, false, false, false]
    }
  },
  methods: {
    toggleCaution(index) {
      this.$set(this.cautionStates, index, !this.cautionStates[index])
    },
    beforeEnter(el) {
      el.style.height = '0'
      el.style.opacity = '0'
    },
    enter(el) {
      const height = el.scrollHeight
      el.style.transition = 'height 0.5s ease, opacity 0.5s ease'
      el.style.height = `${height}px`
      el.style.opacity = '1'
    },
    leave(el) {
      el.style.transition = 'height 0.5s ease, opacity 0.5s ease'
      el.style.height = '0'
      el.style.opacity = '0'
    },
    scrollToSection(targetSelector) {
      const targetElement = document.querySelector(targetSelector)

      if (targetElement) {
        // 요소의 위치와 계산된 스타일 가져오기
        const elementRect = targetElement.getBoundingClientRect()
        const computedStyle = window.getComputedStyle(targetElement)

        // 패딩 및 마진 계산
        const marginTop = parseInt(computedStyle.marginTop)
        const paddingTop = parseInt(computedStyle.paddingTop)

        // 요소의 절대 위치 계산
        const absoluteElementTop = elementRect.top + window.pageYOffset

        // 최종 오프셋 계산 (패딩 및 마진 포함)
        let finalOffset = absoluteElementTop - marginTop - paddingTop

        if (window.innerWidth <= 1022) {
          finalOffset -= 60 // 60px 추가 오프셋
        } else if (window.innerWidth <= 768) {
          finalOffset -= 12
        } else if (window.innerWidth <= 480) {
          finalOffset -= 12
        } else {
          finalOffset -= 120
        }
        window.scrollTo({
          top: finalOffset,
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
// apply
body {
  overflow-y: hidden;
}
.inner {
  max-width: 790px;
  margin: 0 auto;
}
.space {
  margin: 50px 0 5px;
}
.depth1 {
  padding-left: 20px;
}
.depth2 {
  padding-left: 25px;
}
.depth3 {
  padding-left: 30px;
}
img {
  width: 100%;
  height: 100%;
}
main {
  width: 100%;
  margin-bottom: 100px;
}
section {
  position: relative;
  width: 100%;
}
.lapping {
  position: relative;
}
.inner_wrap {
  max-width: 1120px;
  margin: 0 auto;
  text-align: center;
  background: #201756;
}
.yellow {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  font-family: 'pretendard-medium';
  font-weight: 600;
  font-size: 30px;
  line-height: 32px;
  color: #fff;
  &.mt1 {
    margin-top: 30px;
  }
  &.mt3 {
    margin-top: 35px;
  }
  &::after {
    content: '';
    display: block;
    background: url('../../../assets/images/event/2025-1-competition/arrow.png')
      no-repeat center center;
    background-size: contain;
    width: 63px;
    height: 45px;
  }
}
.caution_wrap {
  padding: 100px 100px 65px;
  background-color: #353535;
  user-select: none;
  cursor: pointer;
  &.user_cause {
    padding: 0;
  }
  .txt {
    display: flex;
    align-items: center;
    margin-bottom: 50px;
    font-family: 'pretendard-light';
    font-size: 45px;
    line-height: 45px;
    color: #fff;
    &::after {
      content: '';
      display: block;
      background: url('../../../assets/images/event/2025-1-competition/arrow.png')
        no-repeat center center;
      background-size: contain;
      width: 56px;
      height: 27px;
      transform: rotate(-180deg);
    }
    &.active {
      &::after {
        transform: rotate(0);
      }
    }
  }
  .slide_list {
    margin: 0 auto;
    text-align: left;
    overflow: hidden;
    list-style-type: disc;
    font-size: 22px;
    color: #fff;
    .point_save {
      margin-bottom: 10px;
    }
    li {
    }
    .cau_wrap1 {
      line-height: 43px;
      ul {
        li {
          line-height: 43px;
        }
      }
      h2 {
        font-size: 45px;
        margin: 50px 0 40px;
      }
      p {
      }
    }
  }
}
.apply_txt {
  display: block;
  margin: 0 0 40px;
  font-family: 'pretendard-medium';
  font-weight: 600;
  font-size: 36px;
  line-height: 36px;
  color: #ffea61;
}
.gradi_box {
  position: relative;
  background-color: #fff;
  border-radius: 24px;
  padding: 40px 40px;
  &::before {
    content: '';
    position: absolute;
    inset: 0; /* top, right, bottom, left를 모두 0으로 설정 */
    background: linear-gradient(
      135deg,
      #3f444f 0%,
      #ccd3de 15%,
      #3f444f 40%,
      #ccd3de 55%,
      #3f444f 80%,
      #ccd3de 95%
    );
    border-radius: 20px;
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: exclude;
    -webkit-mask-composite: xor;
    padding: 10px;
  }
  li {
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .topic_wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
    span:nth-child(1) {
      flex: 0.8;
      padding: 15px 0;
      border-radius: 10px;
      letter-spacing: 1px;
      font-family: 'pretendard-medium';
      font-weight: 600;
      font-size: 30px;
    }
    span:nth-child(2) {
      padding: 15px 13px;
      border-radius: 10px;
      letter-spacing: 1px;
      background: linear-gradient(
        to right,
        #e4b670 30%,
        #fdda94 60%,
        #e4b670 90%
      );
      font-family: 'pretendard-medium';
      font-weight: 600;
      font-size: 28px;
      color: #12073f;
    }
    &.naver {
      span:nth-child(1) {
        background-color: #01de5a;
        color: #12073f;
      }
    }
    &.bhc {
      span:nth-child(1) {
        background-color: #966223;
        color: #fff;
      }
    }
    &.mega {
      span:nth-child(1) {
        background-color: #fdd000;
        color: #12073f;
      }
    }
  }
  .name_list {
    text-align: left;
    font-size: 29px;
    color: #9a9a9a;
    display: flex;
    flex-wrap: wrap; /* 화면 크기에 따라 자동 줄바꿈 */
    gap: 10px 15px; /* 세로 간격 10px, 가로 간격 15px */
    user-select: none;
    .txt {
      position: relative;
      display: flex;
      align-items: center;
      cursor: pointer;
      &::after {
        content: '';
        display: block;
        background: url('../../../assets/images/event/2025-1-competition-announcement/arrow_gray.png')
          no-repeat center center;
        background-size: contain;
        width: 54px;
        height: 34px;
        transform: rotate(-180deg);
      }
      &.active {
        &::after {
          transform: rotate(0);
        }
      }
    }
  }
}
// cont
.content1 {
  // padding-bottom: 65px;

  img {
    display: block;
  }
  .txt_wrap {
    position: absolute;
    top: 100px;
    left: 100px;
    text-align: left;
    h2 {
      margin-bottom: 33px;
      font-family: 'pretendard-medium';
      font-weight: 600;
      font-size: 80px;
      line-height: 84px;
      color: #5c61dd;
    }
    span {
      font-size: 40px;
      line-height: 49px;
      color: #000000;
      b {
        font-family: 'pretendard-medium';
        font-weight: 600;
      }
    }
  }
}
.content2 {
  position: relative;
  // height: 1900px;
  .my_collage_wrap {
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
    font-family: 'pretendard-medium';
    font-size: 38px;
    color: #f7d608;
    .my_score {
      flex: 0.62;
      text-align: right;
    }
  }
  .count_user_box {
    position: relative;
    .info {
      max-width: 790px;
      margin: 24px auto 0;
      font-family: 'pretendard-light';
      text-align: left;
      font-size: 26px;
      color: #908bab;
      span {
        font-size: 22px;
      }
    }
    .ribon {
      position: absolute;
      bottom: -151px;
      right: 0px;
      // width: 373px;
      width: 33%;
    }
  }
  .couter_wrap {
    position: relative;
    overflow: hidden;
    width: 790px;
    margin: 0 auto;
    padding: 40px 40px;
    background: linear-gradient(
      135deg,
      #3c3668 0%,
      #4d4679 15%,
      #3c3668 40%,
      #4d4679 55%,
      #3c3668 80%,
      #4d4679 95%
    );
    border-radius: 20px;
    &::before {
      content: '';
      position: absolute;
      inset: 0; /* top, right, bottom, left를 모두 0으로 설정 */
      background: linear-gradient(
        135deg,
        #3f444f 0%,
        #ccd3de 15%,
        #3f444f 40%,
        #ccd3de 55%,
        #3f444f 80%,
        #ccd3de 95%
      );
      border-radius: 20px;
      mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      mask-composite: exclude;
      -webkit-mask-composite: xor;
      padding: 10px;
    }
    li {
      display: flex;
      align-items: center;
      padding: 23px 0;
      border-bottom: 1px solid #6e6991;
      font-size: 40px;
      color: #fff;
      img {
        width: 88px;
        height: 88px;
        margin-right: 10px;
      }
      &:first-child {
        color: #e6c658;
        i {
          background: url('../../../assets/images/event/2025-1-competition/first.png')
            no-repeat center center;
          background-size: contain;
          height: 88px;
          text-indent: -9999px;
        }
      }
      &:nth-child(2) {
        i {
          background: url('../../../assets/images/event/2025-1-competition/second.png')
            no-repeat center center;
          background-size: contain;
          height: 88px;
          text-indent: -9999px;
        }
      }
      &:nth-child(3) {
        i {
          background: url('../../../assets/images/event/2025-1-competition/third.png')
            no-repeat center center;
          background-size: contain;
          height: 88px;
          text-indent: -9999px;
        }
      }
      &:nth-child(n + 4) {
        .collage {
          font-size: 45px;
          line-height: 45px;
        }
      }
      &:last-child {
        border-bottom: none;
      }
      i {
        width: 88px;
        margin-right: 3px;
        font-size: 57px;
      }
      .collage {
        flex-grow: 1;
        font-family: 'pretendard-medium';
        font-weight: 600;
        font-size: 55px;
        line-height: 55px;
        letter-spacing: 1px;
        text-align: left;
      }
      .score {
        font-size: 40px;
        line-height: 40px;
        text-align: right;
      }
    }
  }
}
.content4 {
  position: relative;
  z-index: 1;
  padding: 150px 0 90px;
  text-align: center;
  .inner {
    max-width: 705px;
  }
  &::after {
    content: '';
    position: absolute;
    top: 130px;
    left: 50%;
    transform: translateX(-50%);
    display: block;
    background: url('../../../assets/images/event/2025-1-competition-announcement/content4_back.png')
      no-repeat;
    background-size: cover;
    width: 100%;
    height: 96%;
    z-index: -1;
  }
  .cont4_txt {
    img {
      width: 411px;
    }
  }
  .benefit_list {
    .first,
    .second,
    .third,
    .fourth,
    .fifth {
      margin: 120px 0 45px;
      img {
        width: 97px;
      }
    }
    .first {
      margin: 15px 0 45px;
    }
    .beneforth {
      img {
        width: 523px;
      }
    }
  }
  .user_cause {
    .slide_list {
      width: 820px;
    }
  }
}
@media (max-width: 960px) {
  .content2 {
    // height: 1665px;
  }
  .content2 .couter_wrap li .collage {
    font-size: 44px;
    line-height: 44px;
  }
  .content2 .couter_wrap li img {
    width: 63px;
    height: 63px;
  }
  .content2 .count_user_box .ribon {
    bottom: -67px;
    width: 25%;
  }
  .content2 .count_user_box .info {
    font-size: 23px;
  }
  .content2 .couter_wrap li:nth-child(n + 4) .collage {
    font-size: 35px;
    line-height: 35px;
  }
  .content2 .couter_wrap li {
    padding: 14px 0;
    font-size: 32px;
  }
  .content2 .couter_wrap li i {
    width: 70px;
    font-size: 37px;
  }
  .content2 .couter_wrap li:first-child i {
    height: 60px;
  }
  .content2 .couter_wrap li:nth-child(2) i {
    height: 60px;
  }
  .content2 .couter_wrap li:nth-child(3) i {
    height: 60px;
  }
  .content2 .couter_wrap li .score {
    font-size: 32px;
    line-height: 32px;
  }
  .content2 .existing_member .sub_topic {
    &::before {
      left: 20px;
      width: 100px;
      height: 100px;
    }
  }
  .content2 .new_member .sub_topic {
    &::after {
      right: 20px;
      width: 100px;
      height: 100px;
    }
  }
}
@media (max-width: 768px) {
  //apply
  .yellow {
    font-size: 23px;
    line-height: 23px;
    &::after {
      width: 54px;
    }
  }
  .gradi_box .name_list .txt {
    font-size: 22px;
  }
  .gradi_box .name_list .txt::after {
    width: 31px;
    height: 24px;
  }
  .gradi_box .topic_wrap span:nth-child(1) {
    padding: 5px 0;
    font-size: 19px;
  }
  .gradi_box .topic_wrap span:nth-child(2) {
    padding: 5px 13px;
    font-size: 19px;
  }
  .gradi_box .name_list {
    font-size: 22px;
  }
  .inner {
    max-width: 500px;
  }
  .caution_wrap {
    padding: 45px 0 5px;
    &.user_cause {
      .slide_list {
        width: 590px;
      }
    }
    .txt {
      padding-left: 107px;
      font-size: 28px;
      line-height: 28px;
      letter-spacing: 1px;
    }
    .slide_list {
      width: 460px;
      li {
        font-size: 21px;
      }
    }
  }
  // cont
  .content1 {
    .txt_wrap {
      top: 40px;
      left: 30px;
      h2 {
        font-size: 60px;
        line-height: 63px;
        margin-bottom: 20px;
      }
      span {
        font-size: 25px;
        line-height: 31px;
      }
    }
  }
  .content2 {
    // height: 1465px;
    padding-top: 60px;
    padding-bottom: 50px;
    .my_collage_wrap {
      font-size: 27px;
    }
    .couter_wrap {
      width: 600px;
      padding: 8px 40px;
      li {
        padding: 19px 0;
        i {
          width: 45px;
          margin-right: 15px;
          font-size: 24px;
        }
        .collage {
          font-size: 35px;
          line-height: 35px;
        }
        .score {
          font-size: 28px;
          line-height: 28px;
        }
      }
    }
    .count_user_box {
      .info {
        font-size: 17px;
        max-width: 600px;
        span {
          font-size: 14px;
        }
      }
    }
  }
  .content2 .couter_wrap li img {
    width: 46px;
    height: 46px;
  }
  .content2 .count_user_box .ribon {
    bottom: -28px;
    width: 21%;
  }
  .content2 .couter_wrap li:nth-child(n + 4) .collage {
    font-size: 28px;
    line-height: 28px;
  }
  .content3 {
    padding: 100px 0;
    .cont3_txt {
      div {
        font-size: 35px;
        p {
          span {
            font-size: 31px;
            line-height: 31px;
          }
        }
      }
    }
    .step01,
    .step02 {
      width: 220px;
    }
    .step01 {
      margin: 60px 0 20px;
    }
    .step02 {
      margin-bottom: 20px;
    }
    .or {
      font-size: 28px;
      line-height: 28px;
    }
    .join_go {
      width: 300px;
    }
    .book_go {
      width: 300px;
    }
  }
  .content4 {
    padding: 40px 0 40px;
    .benefit_list {
      span {
        font-size: 27px;
        line-height: 27px;
      }
      .beneforth {
        img {
          width: 398px;
        }
      }
    }
  }
  .gradi_box {
    margin: 0 auto;
    max-width: 540px;
  }
}
@media (max-width: 480px) {
  //apply
  .inner {
    max-width: 350px;
  }
  .gradi_box {
    padding: 30px 20px;
    max-width: 330px;
  }
  .gradi_box .name_list .txt {
    font-size: 17px;
  }
  .gradi_box .name_list .txt::after {
    width: 24px;
    height: 18px;
  }
  .gradi_box .topic_wrap span:nth-child(1) {
    flex: 0.9;
    font-size: 12px;
  }
  .gradi_box .topic_wrap span:nth-child(2) {
    font-size: 12px;
  }
  .gradi_box .name_list {
    font-size: 17px;
  }
  .caution_wrap {
    padding: 35px 0 10px;
    &.user_cause {
      .slide_list {
        width: 347px;
        margin-top: 35px;
      }
    }
    .txt {
      margin-bottom: 22px;
      padding-left: 42px;
      font-size: 20px;
      line-height: 20px;
    }
    .slide_list {
      width: 360px;
      font-size: 16px;
      li {
        font-size: 16px;
      }
      .cau_wrap1 {
        line-height: 36px;
        ul {
          li {
            line-height: 32px;
          }
        }
        h2 {
          font-size: 25px;
          margin: 20px 0 20px;
        }
      }
    }
  }
  //cont
  .content1 {
    .txt_wrap {
      top: 40px;
      left: 30px;
      h2 {
        font-size: 43px;
        line-height: 46px;
        margin-bottom: 14px;
      }
      span {
        font-size: 19px;
        line-height: 24px;
      }
    }
  }
  .content2 {
    // height: 990px;
    padding-top: 40px;
    padding-bottom: 0;
    .my_collage_wrap {
      font-size: 16px;
    }
    .count_user_box {
      .info {
        font-size: 13px;
        max-width: 330px;
        span {
          font-size: 12px;
        }
      }
    }
    .couter_wrap {
      width: 330px;
      padding: 12px 23px;
      li {
        margin-right: 9px;
        padding: 10px 0;
        font-size: initial;
        &:nth-child(1),
        &:nth-child(2),
        &:nth-child(3) {
          i {
            height: 40px;
          }
          .collage {
            font-size: 23px;
            line-height: 23px;
          }
        }
        &:nth-child(n + 4) {
          .collage {
            font-size: 17px;
            line-height: 17px;
          }
        }
        i {
          width: 32px;
          font-size: 17px;
        }
        .score {
          font-size: 17px;
          line-height: 17px;
        }
      }
    }
  }
  .content2 .couter_wrap li img {
    width: 33px;
    height: 33px;
  }
  .content2 .couter_wrap li i {
    margin-right: 6px;
  }
  .content2 .count_user_box .ribon {
    bottom: 5px;
    width: 19%;
  }
  .content3 {
    padding: 0;
    .cont3_txt {
      > div {
        margin-top: 30px;
        font-size: 22px;
        p {
          span {
            font-size: 22px;
            line-height: 22px;
          }
        }
      }
    }
    .step01,
    .step02 {
      width: 135px;
    }
    .step01 {
      margin: 40px 0 10px;
    }
    .step02 {
      margin-bottom: 15px;
    }
    .or {
      margin: 17px 0 22px;
      font-size: 20px;
      line-height: 20px;
    }
    .join_go {
      width: 225px;
      margin: 35px auto 35px;
    }
    .book_go {
      width: 225px;
    }
  }
  .content4 {
    padding: 0 0 30px;
    &::after {
      top: 0;
      height: 100%;
    }
    .cont4_txt {
      img {
        width: 215px;
      }
    }
    .benefit_list {
      .first,
      .second,
      .third,
      .fourth,
      .fifth {
        margin: 90px 0 45px;
        img {
          width: 66px;
        }
      }
      span {
        font-size: 16px;
        line-height: 16px;
      }
    }
  }
}
</style>
